function __$styleInject(css, returnValue) {
  if (typeof document === 'undefined') {
    return returnValue;
  }
  css = css || '';
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  head.appendChild(style);
  
  if (style.styleSheet){
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  return returnValue;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var SvgCoords = function (_Component) {
  inherits(SvgCoords, _Component);

  function SvgCoords() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, SvgCoords);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = SvgCoords.__proto__ || Object.getPrototypeOf(SvgCoords)).call.apply(_ref, [this].concat(args))), _this), _this.getMinX = function () {
      var data = _this.props.data;

      return data.length > 0 ? data[0] : { x: 0, y: 0 };
    }, _this.getMaxX = function () {
      var data = _this.props.data;

      return data.length > 0 ? data[data.length - 1] : { x: 0, y: 0 };
    }, _this.getMinY = function () {
      var data = _this.props.data;

      var initial = data[0] ? data[0] : { x: 0, y: 0 };
      return data.reduce(function (min, p) {
        return p.y < min.y ? p : min;
      }, initial);
    }, _this.getMaxY = function () {
      var data = _this.props.data;

      var initial = data[0] ? data[0] : { x: 0, y: 0 };
      return data.reduce(function (max, p) {
        return p.y > max.y ? p : max;
      }, initial);
    }, _this.getSvgX = function () {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (x) {
        var _this$props = _this.props,
            viewBoxWidth = _this$props.viewBoxWidth,
            yAxisArea = _this$props.yAxisArea;

        var _this$getMaxX = _this.getMaxX(),
            maxX = _this$getMaxX.x;

        return yAxisArea + x / maxX * (viewBoxWidth - yAxisArea);
      }
      return _this.props.yAxisArea;
    }, _this.getSvgY = function () {
      var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (y) {
        var _this$props2 = _this.props,
            viewBoxHeight = _this$props2.viewBoxHeight,
            xAxisArea = _this$props2.xAxisArea;

        var _this$getMinY = _this.getMinY(),
            minY = _this$getMinY.y;

        var _this$getMaxY = _this.getMaxY(),
            maxY = _this$getMaxY.y;

        return ((viewBoxHeight - xAxisArea) * maxY - (viewBoxHeight - xAxisArea) * y) / (maxY - minY);
      }
      return _this.props.xAxisArea;
    }, _this.getChartHelpers = function () {
      return {
        getMinX: _this.getMinX,
        getMaxX: _this.getMaxX,
        getMinY: _this.getMinY,
        getMaxY: _this.getMaxY,
        getSvgX: _this.getSvgX,
        getSvgY: _this.getSvgY
      };
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(SvgCoords, [{
    key: 'render',
    value: function render() {
      return this.props.render(this.getChartHelpers());
    }
  }]);
  return SvgCoords;
}(Component);
SvgCoords.propTypes = {
  viewBoxWidth: PropTypes.number,
  viewBoxHeight: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  })).isRequired,
  render: PropTypes.func.isRequired,
  yAxisArea: PropTypes.number,
  xAxisArea: PropTypes.number
};
// DEFAULT PROPS
SvgCoords.defaultProps = {
  viewBoxWidth: 0,
  viewBoxHeight: 0,
  data: [],
  yAxisArea: 0,
  xAxisArea: 0
};

var SvgCoordsHOC = function SvgCoordsHOC(Comp) {
  var Wrapper = function Wrapper(props) {
    return React.createElement(SvgCoords, { render: function render(coordProps) {
        return React.createElement(Comp, _extends({}, props, coordProps));
      } });
  };
  Wrapper.displayName = 'SvgCoordsHOC(' + (Component.displayName || Component.name) + ')';
  Wrapper.WrappedComponent = Component;
  return hoistNonReactStatics(Wrapper, Component);
};

export { SvgCoords, SvgCoordsHOC };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-coordinates/dist/index.es.js
// module id = 46
// module chunks = 0